import { memo } from "react";

import cls from "./PageLoader.module.css";
import { classNames } from "../../Utils/classNames/classNames";
import { Spinner } from "react-bootstrap";

interface PageLoaderProps {
    className?: string;
}

export const PageLoader = memo((props: PageLoaderProps) => {
    const { className } = props;

    return (
        <div className={classNames(cls.pageLoader, {}, [className])}>
            <Spinner animation="border" variant="primary" />
        </div>
    );
});
